// api/commitCollabPacket.ts
import { registerMutation } from "@adornis/baseql/metadata/register.js";
import { context } from "@adornis/baseql/server/context.js";
import { CollabPacket } from "../db/CollabPacket.js";
import { applyUpdate, ensureRoom } from "../server/room-store.js";
var commitCollabPacket = registerMutation({
  type: () => Boolean,
  operationName: "commitCollabPacket",
  resolve: (roomID, _class, cid, username, type, data) => {
    return async () => {
      if (!roomID || roomID.length > 128) {
        throw new Error("Room ID is required");
      }
      if (username.length > 64) {
        throw new Error("Username is too long");
      }
      const room = await ensureRoom(roomID, _class);
      if (!room) {
        throw new Error(`Room ${roomID} does not exist`);
      }
      const userID = context.serverContext ? cid : context.userID ?? cid;
      const packet = new CollabPacket({
        userID,
        //Use context.userID if available; otherwise, fallback to cid for server-side.
        targetClass: _class,
        username,
        type,
        roomID,
        cid,
        payload: data
      });
      await applyUpdate(room, packet);
      return true;
    };
  },
  params: [
    {
      name: "roomID",
      type: () => String
    },
    {
      name: "_class",
      type: () => String
    },
    {
      name: "cid",
      type: () => String
    },
    {
      name: "username",
      type: () => String
    },
    {
      name: "type",
      type: () => String
    },
    {
      name: "data",
      type: () => String
    }
  ]
});
export {
  commitCollabPacket
};
